import { Box, IconButton, Typography, useTheme } from "@mui/material";
import {
  DeleteSweep,
  AddCircleOutlineOutlined,
  RemoveCircleOutlineOutlined,
} from "@mui/icons-material";
import { FilterSection } from "./FilterSection";
import {
  INCLUDE_EXCLUDE_BORDER,
  INCLUDE_EXCLUDE_HEIGHT_OF_HEADER,
} from "../IncludeExcludeFilter";
import {
  IncludeExcludeFilterCategory,
  FilterAction,
  FilterState,
} from "../reducers/includeExcludeFilterReducer";

export const FilterListDisplay = ({
  totalSelectedFilters,
  getCategoryLabel,
  validCategories,
  filterSelectionState,
  dispatch,
  onClearAll,
  onCategoryClear,
}: {
  totalSelectedFilters: number;
  getCategoryLabel: (categoryId: string) => string;
  validCategories: IncludeExcludeFilterCategory[];
  filterSelectionState: FilterState;
  dispatch: React.Dispatch<FilterAction>;
  onClearAll?: () => void;
  onCategoryClear?: (categoryId: string, filterType: "include" | "exclude") => void;
}) => {
  const theme = useTheme();
  return (
    <Box width={300} overflow="auto">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        padding={2}
        sx={{
          borderBottom: INCLUDE_EXCLUDE_BORDER,
          height: INCLUDE_EXCLUDE_HEIGHT_OF_HEADER,
        }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          {totalSelectedFilters} filter
          {totalSelectedFilters !== 1 ? "s" : ""} selected
        </Typography>
        <IconButton
          onClick={() => {
            dispatch({type: "CLEAR_ALL"});
            onClearAll?.();
          }}
        >
          <DeleteSweep
            sx={{
              cursor: "pointer",
              color: "text.secondary",
              fontSize: "18px",
            }}
          />
        </IconButton>
      </Box>

      <FilterSection
        type="include"
        icon={<AddCircleOutlineOutlined />}
        label="Include"
        iconColor={theme.palette.success.main}
        getCategoryLabel={getCategoryLabel}
        validCategories={validCategories}
        filterSelectionState={filterSelectionState}
        dispatch={dispatch}
        onCategoryClear={onCategoryClear}
      />
      <FilterSection
        type="exclude"
        icon={<RemoveCircleOutlineOutlined />}
        label="Exclude"
        iconColor={theme.palette.error.light}
        getCategoryLabel={getCategoryLabel}
        validCategories={validCategories}
        filterSelectionState={filterSelectionState}
        dispatch={dispatch}
        onCategoryClear={onCategoryClear}
      />
    </Box>
  );
};
